import getMobileOperatingSystem from '../../utils/DetectDeviceType';
import { gtmEventPush } from '../../../modules/ga/GTMdatalayer';
import { isPhoneUserAgent } from '../../../utils/loginUtil';
import isNode from '../../../modules/ajio-util/isNode';

const utmCampaign: Record<string, string> = {
  homepage: 'homepage',
  pdp: 'pdp',
  plp: 'plp',
  orderListing: 'order_listing',
  orderConfirm: 'order_confirmation',
  footer: 'footer'
};

const triggerApp = (
  appConfig: import('../../types/firebaseFlags').AppConfig,
  pagetype: string,
  componentType?: string,
  appsFlyerConfig?: Object 
): void => {
  if (isNode()) {
    return;
  }
  gtmEventPush({
    event: 'app_install_widget_interaction',
    category: 'widget interaction',
    action: 'app install widget interaction',
    label: 'install'
  });
  const utmSource = 'msite';
  const utmMedium = 'web2app';
  const gaString = `&utm_source=${utmSource}&utm_medium=${utmMedium}&utm_campaign=${
    utmCampaign[pagetype]
  }${pagetype === 'pdp' && componentType ? `_${componentType}` : ''}`;

 console.log("APPS FLYER CONFIG", appsFlyerConfig)

 //To generate Onelink URL.
  const result = window?.AF_SMART_SCRIPT?.generateOneLinkURL(appsFlyerConfig);
    console.log("APPS result",result)
    if(result?.clickURL){
      window.location.href = result.clickURL;
   } else {
    const device = getMobileOperatingSystem();
    let deepLink = window.location.href || '';
    const regex = new RegExp(/\?.*/);
    deepLink = deepLink.replace(regex, '');
    console.log('url link', deepLink);
    if (device === 'iOS') {
      const {
        iosPackageName = 'com.ril.ajio',
        iosSubDomain = 'ajio',
        iosUrlScheme = 'ajioapps',
        iosStoreId = '1113425372'
      } = appConfig;
      console.log(
        'check link to test',
        `https://${iosSubDomain}.page.link/?link=${deepLink}&ibi=${iosPackageName}&isi=${iosStoreId}&ius=${iosUrlScheme}${gaString}`
      );
      window.location.href = `https://${iosSubDomain}.page.link/?link=${deepLink}&ibi=${iosPackageName}&isi=${iosStoreId}&ius=${iosUrlScheme}${gaString}`;
    } else {
      const { androidPackageName = 'com.ril.ajio', androidSubDomain = 'ajio' } = appConfig;
      console.log(
        'check link to test',
        `https://${androidSubDomain}.page.link/?link=${deepLink}&apn=${androidPackageName}${gaString}`
      );
      window.location.href = `https://${androidSubDomain}.page.link/?link=${deepLink}&apn=${androidPackageName}${gaString}`;
    }
  }
};

const handleCloseBanner = (): void => {
  if (isNode()) {
    return;
  }
  sessionStorage.setItem('bannerClosed', 'true');
};

const checkNewUser = (): boolean => {
  if (isNode()) {
    return false;
  }
  const { customerType = '' } = JSON.parse(sessionStorage.getItem('customerTypeData')) || {};
  return customerType?.toUpperCase() !== 'EXISTING';
};

const checkAppInstall = (): boolean => {
  if (isNode()) {
    return false;
  }
  if (navigator && navigator.getInstalledRelatedApps) {
    navigator.getInstalledRelatedApps().then(relatedApps => {
      if (relatedApps?.length > 0) {
        return true;
      }
    });
  }

  return false;
};

const isMicroApp = (): boolean => {
  if (isNode()) {
    return false;
  }
  if (
    sessionStorage.getItem('gpay') === 'true' ||
    sessionStorage.getItem('phonepe') === 'true' ||
    isPhoneUserAgent()
  ) {
    return true;
  }
  return false;
};

export { triggerApp, handleCloseBanner, checkNewUser, checkAppInstall, isMicroApp };
